import { render, staticRenderFns } from "./TicketManagePage.vue?vue&type=template&id=3b89964c&scoped=true&"
import script from "./TicketManagePage.vue?vue&type=script&lang=js&"
export * from "./TicketManagePage.vue?vue&type=script&lang=js&"
import style0 from "./TicketManagePage.vue?vue&type=style&index=0&id=3b89964c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89964c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VSnackbar,VTextField,VTextarea})
